import { reduxForm } from 'redux-form';
import Component from './CustomerSearchForm.jsx';
import validate from './validate.js';

const initialValues = {
  nationalityId: '',
};

const CustomerSearchForm = reduxForm({
  form: 'customerSearchForm',
  initialValues,
  enableReinitialize: true,
  validate,
})(Component);

export default CustomerSearchForm;
